import mitt from 'mitt';
import { EventName } from '@/constants';
import type { IWebSocketUserRow } from '@/types/webSocketUser';

type Events = {
    [EventName.PageReload]: { page: string | string[] | null } | undefined;
    [EventName.BrowserTabVisibilityChanged]: { isBrowserTabInactive: boolean; browserTabInactiveTimeSec?: number };
    [EventName.LanguageChanged]: string;
    [EventName.PageResize]: void;
    [EventName.WebSocketUsers]: IWebSocketUserRow[];
};

const eventBus = mitt<Events>();

export default eventBus;
